import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import { useStore, StoreTypes } from 'context';
import { ExtensionType } from 'constants/wordGrid';
import WordExample from 'components/WordExample';
import { WordGridSubContentPanel } from './wordGridSubContent/WordGridSubContentPanel';

// 判斷 wordExampleResource 是否為「新版生字庫 subcontent 面板」可渲染的格式。
// 新版 WordsSet 的語詞教學完全由 ContentPath/Content 指向的 HTML JSON 畫直書格線；
// 舊版（圖片＋發音卡）的 WordsSet 只有 Audio/Path/Label、沒有 ContentPath 也沒有 Content，
// 丟進新版 panel 會得到空白格線且抓內容的 Promise 卡住，故此類資料需退回舊版 <WordExample>。
const isSubContentPanelCompatible = (resource) => {
  if (!resource || typeof resource !== 'object') return false;
  return Object.values(resource).some(
    (v) =>
      v &&
      Array.isArray(v.WordsSet) &&
      v.WordsSet.some((it) => it && (it.ContentPath || it.Content))
  );
};

// 課文「橘框語詞」直接開啟時，改用新版生字庫 subcontent 面板呈現「語詞教學」。
const WordExamplePanel = ({ wordExampleResource, defaultWord, isZhuyin }) => {
  const [{ bookId, books }] = useStore(StoreTypes.books);
  const book = books.find(info => info.bookId === bookId);
  const isElementaryHighGrade = !!book && (
    book.display_name.includes('國小國語5') || book.display_name.includes('國小國語6')
  );

  const resource = wordExampleResource || {};
  // WordExample 資料的 WordsSet item 用 ContentPath；面板/純函式讀 Content，故正規化對映。
  const allWords = Object.entries(resource).map(([key, v]) => ({
    word: key,
    extensionData: {
      meaningSet: [],
      idiomSet: [],
      glyphSet: [],
      wordsSet: ((v && v.WordsSet) || []).map(it => ({ ...it, Content: it.ContentPath || it.Content })),
    },
  }));

  const wordsList = Object.entries(resource).map(([key, v]) => ({
    label: (v && (v.Label || v.Word || v.label || v.word)) || key,
    value: key,
    relatedWords: [key],
  }));

  return (
    <WordGridSubContentPanel
      allWords={allWords}
      bookId={bookId}
      initialWord={defaultWord}
      initialExtensionType={ExtensionType.WordsSet}
      isElementaryHighGrade={isElementaryHighGrade}
      isZhuyin={isZhuyin}
      wordsList={wordsList}
    />
  );
};

export const WordExampleModalComponent = ({ wordExampleResource, defaultWord, isZhuyin }) => {
  // 舊格式（圖片＋發音卡，WordsSet 無 ContentPath/Content）：走原本的 <WordExample>，維持既有呈現。
  if (!isSubContentPanelCompatible(wordExampleResource)) {
    return (
      <ExtendedContentContainer extendedContentType={ExtendedContentType.WordExample}>
        <WordExample data={wordExampleResource} defaultWord={defaultWord} isZhuyin={isZhuyin} />
      </ExtendedContentContainer>
    );
  }

  // 相容新版格式：走生字庫 subcontent 面板呈現「語詞教學」。
  return (
    <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGridSubContent}>
      <WordExamplePanel
        wordExampleResource={wordExampleResource}
        defaultWord={defaultWord}
        isZhuyin={isZhuyin}
      />
    </ExtendedContentContainer>
  );
};
